<template>
<div id="add-manual-invoice">
  <manual-invoice-detail-dialog ref="manualInvoiceDetailDialog" :invoice="invoiceAdded" :show-icon-grid="false" />
  <el-button id="btn-add-manual-invoice" type="success" plain size="mini" @click="handleOpenDialog" v-if="canEditInvoice"
  >{{ $t('invoices.addManualInvoice') }}</el-button>
  <el-dialog
          :close-on-click-modal="false"
          :title=" $t('invoices.addManualInvoice')"
          :visible.sync="dialogVisible"
          width="65%"
          class="dialog-with-cols">
    <el-form :model="editForm" :rules="editFormRules" ref="editForm" size="mini">
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.billTo')" prop="billToAccountId" ref="billToAccountId" class="inline-input">
            <autocomplete
                    :model.sync="editForm.billToAccountId"
                    labelFieldLastWithDash="number"
                    popperAppendToBody
                    :url="urlBillTo"
                    labelField="name"
                    valueField="id"
                    ref="rows-billto"
                    id="rows-billto"
                    class="inline-input"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.customer')" prop="consigneeAccountId" ref="consigneeAccountId" class="inline-input">
            <autocomplete
                    :model.sync="editForm.consigneeAccountId"
                    labelFieldLastWithDash="number"
                    popperAppendToBody
                    :url="urlCustomer"
                    labelField="name"
                    valueField="id"
                    ref="rows-consignee"
                    id="rows-consignee"
            />
          </el-form-item>
        </el-col>

        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.date')" prop="date" ref="date" class="inline-input">
            <el-date-picker
                    class="el-dropdown-new drop-sp date-dob"
                    size="mini"
                    v-model="editForm.date"
                    format="MM/dd/yyyy"
                    :clearable="false"
                    type="date"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.loadNum')" prop="loadNum" class="inline-input">
              <autocomplete
                      :model.sync="editForm.loadNumber"
                      :text.sync="editForm.loadNumber"
                      labelFieldLastWithDash="number"
                      popperAppendToBody
                      :url="urlLoads"
                      labelField="loadNumber"
                      valueField="loadNumber"
                      ref="rows-load"
                      id="rows-load"
                      class="inline-input"
                      />
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.incidentNum')" prop="caseNumber" class="inline-input">
            <el-input
                    size="mini"
                    v-model="editForm.caseNumber"
                    v-alphanumeric-validation
                    maxlength="20"
                    clearable
                    class="inline-input"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('invoices.internalAdjustment')" prop="internalAdjustment" ref="internalAdjustment" class="inline-input">
            <el-select size="mini" v-model="editForm.internalAdjustment">
              <el-option :label="yes.label" :value="yes.value"></el-option>
              <el-option :label="no.label" :value="no.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div id="edit-manual-invoice-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="handleSave()" size="mini">{{ $t('invoices.addManualInvoice') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import ManualInvoiceDetailDialog from './ManualInvoiceDetailDialog';

export default {
  name: 'AddManualInvoiceDialog',
  components: { Autocomplete, ManualInvoiceDetailDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canEditInvoice() {
      return this.$can(this.permissions.BILLING.EDIT_INVOICE);
    }
  },
  data() {
    return {
      invoiceAdded: {
        type: null
      },
      dialogVisible: false,
      yes: constants.STATUS_BOOLEAN.yes,
      no: constants.STATUS_BOOLEAN.no,
      editForm: {
        date: new Date(),
        billToAccountId: null,
        consigneeAccountId: null,
        internalAdjustment: null,
        caseNumber: null,
        loadNumber: null,
      },
      editFormRules: {
        date: [
          {
            required: true,
            message: this.$t('invoices.manual.error.dateRequired'),
            trigger: 'blur'
          }
        ],
        billToAccountId: [
          {
            required: true,
            message: this.$t('invoices.manual.error.billToAccountRequired'),
            trigger: 'submit'
          }
        ]
      },
      urlBillTo: `${apiConstants.END_POINTS.ACCOUNTS.ALL_BY_TYPE.replace('{accountTypeId}', '0')}/1`,
      urlCustomer: apiConstants.END_POINTS.ACCOUNTS.DEFAULT,
      urlLoads: apiConstants.END_POINTS.LOADS.SEARCH,
    };
  },
  methods: {
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('invoices/addInvoice', this.editForm).then((response) => {
              this.invoiceAdded = response.data;
              this.$message.success(response.message);
              this.$store.dispatch('invoices/search', {});
              loading.close();
              this.dialogVisible = false;
              if (this.$refs && this.$refs.manualInvoiceDetailDialog) {
                this.$nextTick(() => {
                  this.$refs.manualInvoiceDetailDialog.handleOpenDialog();
                });
              }
            });
        }
      });
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs && this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.editForm.internalAdjustment = this.no.value;
      this.editForm.loadNumber = null;
      this.clearAutocomplete();
    },
    clearAutocomplete() {
      this.editForm.billToAccountId = null;
      this.editForm.consigneeAccountId = null;
      this.editForm.loadNumber = null;
      if (this.$refs['rows-billto']) {
        this.$refs['rows-billto'].clearLocalModel();
      }
      if (this.$refs['rows-consignee']) {
        this.$refs['rows-consignee'].clearLocalModel();
      }
      if (this.$refs['rows-load']) {
        this.$refs['rows-load'].clearLocalModel();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  #add-manual-invoice  {
    padding-bottom: 5px;
    display: inline-block;
    .el-select, .el-date-editor {
      width: 100% !important;
    }
  }
</style>
